import React, { useEffect, useContext } from 'react';
import { PropTypes } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useDataModel } from '@thd-nucleus/data-sources';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { Rating } from '@thd-olt-component-react/rating';
import { dataModel } from '../components/ratings-and-reviews-data-model';
import './BrandRating.scss';
import * as analytics from '../../analytics';
import BrandRatingModel from './BrandRatingModel';

export const BrandRating = ({ parentNode, itemId, brandName }) => {
  const opts = {
    ssr: false,
    variables: {
      itemId
    }
  };
  const { channel } = useContext(ExperienceContext);
  const [
    reviewSentimentsRequest,
    reviewSentimentsResponse,
    reviewSentimentsVariables
  ] = useDataModel('reviewSentiments', opts, true);

  const variables = {
    filters: {
      isVerifiedPurchase: false,
      prosCons: null,
      starRatings: null
    },
    searchTerm: null,
    sortBy: 'photoreview',
    startIndex: 1
  };
  const { data: rData, error: rError, loading: rLoading } = useDataModel('reviews', {
    variables: { ...variables, itemId },
    ssr: true,
    skip: false
  });

  const model = new BrandRatingModel(reviewSentimentsResponse?.data, rData);
  /* eslint-disable no-unused-expressions */
  useEffect(() => {
    if (parentNode && !model.errors) {
      parentNode && parentNode.classList.add('brand-rating-flex');
    }
  }, [parentNode, rData, reviewSentimentsResponse?.data]);

  useEffect(() => {
    if (rData?.reviews?.TotalResults <= 10) {
      setTimeout(() => {
        reviewSentimentsRequest(reviewSentimentsVariables);
      }, 1000);
    }
  }, [rData]);

  if ((rError && !rData) || !rData || rLoading || model.errors) {
    return null;
  }

  /* eslint-enable no-unused-expressions */

  const handleOnShow = () => {
    analytics.track('click', {
      element: 'brandRating'
    });
  };

  const formatBrandTotal = (total) => {
    if (total > 9999) {
      return `${Math.round(total / 100) / 10}k`;
    }
    return total.toString();

  };

  const { totalReviewCount, averageBrandRating, skuReviewCount } = model;
  const averageRatingText = averageBrandRating.toFixed(1);

  if (totalReviewCount <= skuReviewCount) {
    return null;
  }

  return (
    <span className="brand-rating">
      (Brand Rating: {averageRatingText}/5)
      <Tooltip
        channel="desktop"
        interactive
        distance={15}
        placement="bottom"
        onShow={handleOnShow}
        triggerTarget={channel === 'mobile' ? parentNode : this}
        content={(
          <div className="brand-rating-wrapper">
            <div className="brand-rating-bold">
              Brand Rating
            </div>
            <div className="brand-rating-reviews">
              <Rating value={averageBrandRating} />
              <span className="review-count">({formatBrandTotal(totalReviewCount)})</span>
            </div>
            <div>
              On average, customers rated <br />
              <span className="brand-rating-bold">
                {brandName}
              </span>
              &nbsp;products
              <span className="brand-rating-bold">
                {averageRatingText}
              </span>
              &nbsp;out of
              <span className="brand-rating-bold">
              &nbsp;5
              </span>
              &nbsp;stars overall.
            </div>
          </div>
        )}
      >
        <span className="brand-rating-info-icon" />
      </Tooltip>
    </span>
  );
};

let HTMLDivElement = null;
try {
  HTMLDivElement = window.HTMLDivElement;
  /* eslint-disable-next-line no-empty */
} catch (error) {}

BrandRating.propTypes = {
  parentNode: PropTypes.instanceOf(HTMLDivElement),
  itemId: PropTypes.string,
  brandName: PropTypes.string
};

BrandRating.defaultProps = {
  parentNode: null,
  itemId: null,
  brandName: '',
};

BrandRating.dataModel = {
  reviewSentiments: dataModel.reviewSentiments,
  reviews: dataModel.reviews
};
